import React from 'react'
import styled from 'styled-components'
import { Svg, SvgProps, Text, Flex } from '@pancakeswap/uikit'

export const PinkBall: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 32 32" {...props}>
      <circle cx="16" cy="16" r="16" fill="#D750B2" />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.3428 3.13232C28.9191 8.87177 28.5505 17.2573 23.2373 22.5706C17.528 28.2799 8.27148 28.2799 2.56223 22.5706C2.2825 22.2909 2.01648 22.0026 1.76416 21.7067C4.02814 27.3486 9.54881 31.3326 16 31.3326C24.4683 31.3326 31.3332 24.4677 31.3332 15.9994C31.3332 10.6078 28.5504 5.8661 24.3428 3.13232Z"
          fill="black"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.7713 4.18262C30.6308 10.2119 30.2607 19.061 24.6609 24.6608C19.0615 30.2602 10.2132 30.6307 4.18396 25.7722C6.99643 29.1689 11.2455 31.3329 16 31.3329C24.4683 31.3329 31.3332 24.468 31.3332 15.9997C31.3332 11.2446 29.1687 6.99508 25.7713 4.18262Z"
          fill="black"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.48969 24.8677C0.151051 18.7651 0.974979 11.0636 6.01931 6.01927C11.0639 0.974682 18.7659 0.15093 24.8687 3.49016C22.365 1.71201 19.3046 0.666603 16 0.666603C7.53165 0.666603 0.666733 7.53152 0.666733 15.9998C0.666733 19.3041 1.7119 22.3642 3.48969 24.8677Z"
          fill="white"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.10075 9.5143C3.77271 5.93677 6.78528 3.11129 10.4921 1.68422C10.546 1.73235 10.5987 1.78219 10.6502 1.83374C12.4838 3.66728 10.9119 5.7442 8.66145 7.99465C6.411 10.2451 4.33417 11.8169 2.50064 9.98335C2.35338 9.83609 2.22013 9.6793 2.10075 9.5143Z"
          fill="white"
        />
      </g>
    </Svg>
  )
}

export const LilacBall: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 32 32" {...props}>
      <circle cx="16" cy="16" r="16" fill="#A881FC" />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.3428 3.13232C28.9191 8.87177 28.5505 17.2573 23.2373 22.5706C17.528 28.2799 8.27148 28.2799 2.56223 22.5706C2.2825 22.2909 2.01648 22.0026 1.76416 21.7067C4.02814 27.3486 9.54881 31.3326 16 31.3326C24.4683 31.3326 31.3332 24.4677 31.3332 15.9994C31.3332 10.6078 28.5504 5.8661 24.3428 3.13232Z"
          fill="black"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.7713 4.18262C30.6308 10.2119 30.2607 19.061 24.6609 24.6608C19.0615 30.2602 10.2132 30.6307 4.18396 25.7722C6.99643 29.1689 11.2455 31.3329 16 31.3329C24.4683 31.3329 31.3332 24.468 31.3332 15.9997C31.3332 11.2446 29.1687 6.99508 25.7713 4.18262Z"
          fill="black"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.48969 24.8677C0.151051 18.7651 0.974979 11.0636 6.01931 6.01927C11.0639 0.974682 18.7659 0.15093 24.8687 3.49016C22.365 1.71201 19.3046 0.666603 16 0.666603C7.53165 0.666603 0.666733 7.53152 0.666733 15.9998C0.666733 19.3041 1.7119 22.3642 3.48969 24.8677Z"
          fill="white"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.10075 9.5143C3.77271 5.93677 6.78528 3.11129 10.4921 1.68422C10.546 1.73235 10.5987 1.78219 10.6502 1.83374C12.4838 3.66728 10.9119 5.7442 8.66145 7.99465C6.411 10.2451 4.33417 11.8169 2.50064 9.98335C2.35338 9.83609 2.22013 9.6793 2.10075 9.5143Z"
          fill="white"
        />
      </g>
    </Svg>
  )
}

export const TealBall: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 32 32" {...props}>
      <circle cx="16" cy="16" r="16" fill="#1FC7D4" />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.3428 3.13232C28.9191 8.87177 28.5505 17.2573 23.2373 22.5706C17.528 28.2799 8.27148 28.2799 2.56223 22.5706C2.2825 22.2909 2.01648 22.0026 1.76416 21.7067C4.02814 27.3486 9.54881 31.3326 16 31.3326C24.4683 31.3326 31.3332 24.4677 31.3332 15.9994C31.3332 10.6078 28.5504 5.8661 24.3428 3.13232Z"
          fill="black"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.7713 4.18262C30.6308 10.2119 30.2607 19.061 24.6609 24.6608C19.0615 30.2602 10.2132 30.6307 4.18396 25.7722C6.99643 29.1689 11.2455 31.3329 16 31.3329C24.4683 31.3329 31.3332 24.468 31.3332 15.9997C31.3332 11.2446 29.1687 6.99508 25.7713 4.18262Z"
          fill="black"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.48969 24.8677C0.151051 18.7651 0.974979 11.0636 6.01931 6.01927C11.0639 0.974682 18.7659 0.15093 24.8687 3.49016C22.365 1.71201 19.3046 0.666603 16 0.666603C7.53165 0.666603 0.666733 7.53152 0.666733 15.9998C0.666733 19.3041 1.7119 22.3642 3.48969 24.8677Z"
          fill="white"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.10075 9.5143C3.77271 5.93677 6.78528 3.11129 10.4921 1.68422C10.546 1.73235 10.5987 1.78219 10.6502 1.83374C12.4838 3.66728 10.9119 5.7442 8.66145 7.99465C6.411 10.2451 4.33417 11.8169 2.50064 9.98335C2.35338 9.83609 2.22013 9.6793 2.10075 9.5143Z"
          fill="white"
        />
      </g>
    </Svg>
  )
}

export const AquaBall: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 32 32" {...props}>
      <circle cx="16" cy="16" r="16" fill="#31D0AA" />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.3428 3.13232C28.9191 8.87177 28.5505 17.2573 23.2373 22.5706C17.528 28.2799 8.27148 28.2799 2.56223 22.5706C2.2825 22.2909 2.01648 22.0026 1.76416 21.7067C4.02814 27.3486 9.54881 31.3326 16 31.3326C24.4683 31.3326 31.3332 24.4677 31.3332 15.9994C31.3332 10.6078 28.5504 5.8661 24.3428 3.13232Z"
          fill="black"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.7713 4.18262C30.6308 10.2119 30.2607 19.061 24.6609 24.6608C19.0615 30.2602 10.2132 30.6307 4.18396 25.7722C6.99643 29.1689 11.2455 31.3329 16 31.3329C24.4683 31.3329 31.3332 24.468 31.3332 15.9997C31.3332 11.2446 29.1687 6.99508 25.7713 4.18262Z"
          fill="black"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.48969 24.8677C0.151051 18.7651 0.974979 11.0636 6.01931 6.01927C11.0639 0.974682 18.7659 0.15093 24.8687 3.49016C22.365 1.71201 19.3046 0.666603 16 0.666603C7.53165 0.666603 0.666733 7.53152 0.666733 15.9998C0.666733 19.3041 1.7119 22.3642 3.48969 24.8677Z"
          fill="white"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.10075 9.5143C3.77271 5.93677 6.78528 3.11129 10.4921 1.68422C10.546 1.73235 10.5987 1.78219 10.6502 1.83374C12.4838 3.66728 10.9119 5.7442 8.66145 7.99465C6.411 10.2451 4.33417 11.8169 2.50064 9.98335C2.35338 9.83609 2.22013 9.6793 2.10075 9.5143Z"
          fill="white"
        />
      </g>
    </Svg>
  )
}

export const GreenBall: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 32 32" {...props}>
      <circle cx="16" cy="16" r="16" fill="#93D45A" />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.3428 3.13232C28.9191 8.87177 28.5505 17.2573 23.2373 22.5706C17.528 28.2799 8.27148 28.2799 2.56223 22.5706C2.2825 22.2909 2.01648 22.0026 1.76416 21.7067C4.02814 27.3486 9.54881 31.3326 16 31.3326C24.4683 31.3326 31.3332 24.4677 31.3332 15.9994C31.3332 10.6078 28.5504 5.8661 24.3428 3.13232Z"
          fill="black"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.7713 4.18262C30.6308 10.2119 30.2607 19.061 24.6609 24.6608C19.0615 30.2602 10.2132 30.6307 4.18396 25.7722C6.99643 29.1689 11.2455 31.3329 16 31.3329C24.4683 31.3329 31.3332 24.468 31.3332 15.9997C31.3332 11.2446 29.1687 6.99508 25.7713 4.18262Z"
          fill="black"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.48969 24.8677C0.151051 18.7651 0.974979 11.0636 6.01931 6.01927C11.0639 0.974682 18.7659 0.15093 24.8687 3.49016C22.365 1.71201 19.3046 0.666603 16 0.666603C7.53165 0.666603 0.666733 7.53152 0.666733 15.9998C0.666733 19.3041 1.7119 22.3642 3.48969 24.8677Z"
          fill="white"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.10075 9.5143C3.77271 5.93677 6.78528 3.11129 10.4921 1.68422C10.546 1.73235 10.5987 1.78219 10.6502 1.83374C12.4838 3.66728 10.9119 5.7442 8.66145 7.99465C6.411 10.2451 4.33417 11.8169 2.50064 9.98335C2.35338 9.83609 2.22013 9.6793 2.10075 9.5143Z"
          fill="white"
        />
      </g>
    </Svg>
  )
}

export const YellowBall: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 32 32" {...props}>
      <circle cx="16" cy="16" r="16" fill="#FFC43C" />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.3428 3.13245C28.9191 8.87189 28.5505 17.2575 23.2373 22.5707C17.528 28.28 8.27148 28.28 2.56223 22.5707C2.2825 22.291 2.01648 22.0028 1.76416 21.7068C4.02814 27.3487 9.54881 31.3327 16 31.3327C24.4683 31.3327 31.3332 24.4678 31.3332 15.9995C31.3332 10.6079 28.5504 5.86622 24.3428 3.13245Z"
          fill="black"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.7714 4.18262C30.6309 10.2119 30.2608 19.061 24.661 24.6608C19.0616 30.2602 10.2134 30.6307 4.18408 25.7722C6.99655 29.1689 11.2456 31.3329 16.0001 31.3329C24.4685 31.3329 31.3334 24.468 31.3334 15.9997C31.3334 11.2446 29.1689 6.99508 25.7714 4.18262Z"
          fill="black"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.48969 24.8677C0.151051 18.7651 0.974979 11.0636 6.01931 6.01927C11.0639 0.974682 18.7659 0.15093 24.8687 3.49016C22.365 1.71201 19.3046 0.666603 16 0.666603C7.53165 0.666603 0.666733 7.53152 0.666733 15.9998C0.666733 19.3041 1.7119 22.3642 3.48969 24.8677Z"
          fill="white"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.10087 9.51443C3.77283 5.93689 6.78541 3.11142 10.4922 1.68435C10.5461 1.73247 10.5988 1.78231 10.6504 1.83387C12.4839 3.6674 10.912 5.74432 8.66157 7.99477C6.41112 10.2452 4.33429 11.817 2.50076 9.98347C2.3535 9.83621 2.22025 9.67943 2.10087 9.51443Z"
          fill="white"
        />
      </g>
    </Svg>
  )
}

export const BallTextWrapper = styled.div`
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
`

export const BallText = styled(Text)<{ rotationTransform?: number }>`
  color: #000000;
  text-shadow: -0.75px -0.75px 0 white, 0.75px -0.75px 0 white, -0.75px 0.75px 0 white, 0.75px 0.75px 0 white;
  transform: rotate(${({ rotationTransform }) => rotationTransform || 0}deg);
`

export type BallColor = 'pink' | 'lilac' | 'teal' | 'aqua' | 'green' | 'yellow'

interface BallWithNumberProps {
  color: BallColor
  number: string
  size?: string
  fontSize?: string
  rotationTransform?: number
}

const ballsMap = {
  pink: PinkBall,
  lilac: LilacBall,
  teal: TealBall,
  aqua: AquaBall,
  green: GreenBall,
  yellow: YellowBall,
}

export const BallWithNumber: React.FC<BallWithNumberProps> = ({ color, number, size, fontSize, rotationTransform }) => {
  const BallComponent = ballsMap[color]
  return (
    <Flex alignItems="center" justifyContent="center" position="relative" mx="2px">
      <BallComponent width={size ?? '32px'} height={size ?? '32px'} />
      <BallTextWrapper>
        <BallText rotationTransform={rotationTransform} bold fontSize={fontSize ?? '16px'}>
          {number}
        </BallText>
      </BallTextWrapper>
    </Flex>
  )
}
